/** Production pre-launch gate — set `VITE_COMING_SOON=true` in `.env.production`. */
export function isComingSoonMode(): boolean {
  return import.meta.env.VITE_COMING_SOON === 'true'
}
